import { render, staticRenderFns } from "./cnpj.vue?vue&type=template&id=74d91c7d"
import script from "./cnpj.ts?vue&type=script&lang=js&external"
export * from "./cnpj.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d91c7d')) {
      api.createRecord('74d91c7d', component.options)
    } else {
      api.reload('74d91c7d', component.options)
    }
    module.hot.accept("./cnpj.vue?vue&type=template&id=74d91c7d", function () {
      api.rerender('74d91c7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/cnpj.vue"
export default component.exports